import { MutationTree } from 'vuex'
import { Consumer } from '@/app/identity'
import { AuthState } from './state'
import tokenTimeoutService from '@/app/auth/services/token-timeout.service'

export const mutations: MutationTree<AuthState> = {
    updateConsumer(state: AuthState, consumer: Consumer) {
        state.consumer = consumer
    },

    updateTokens(state: AuthState, { accessToken, refreshToken }: { accessToken: string, refreshToken: string }) {
        state.accessToken = accessToken
        state.refreshToken = refreshToken
        
        // Set timeout for token expiration with automatic refresh
        tokenTimeoutService.setTokenTimeout(accessToken)
    },

    updateProductActionToken(state: AuthState, { id, token }: { id: string, token: string }) {
        state.tempLogin = { id, token }
    },

    removeProductActionToken(state: AuthState) {
        state.tempLogin = {}
    },

    updatePendingLogin(
        state: AuthState,
        { accessToken, refreshToken }: { accessToken: string, refreshToken: string }
    ) {
        state.pendingCredentials = { accessToken, refreshToken }
    },

    clearPendingLogin(state: AuthState) {
        state.pendingCredentials = {}
    },

    logout(state: AuthState) {
        state.consumer = undefined
        state.accessToken = undefined
        state.refreshToken = undefined
        
        // Clear any existing token timeout
        tokenTimeoutService.clearTokenTimeout()
    },

    setTwoFactorStatus(state: AuthState, { enabled, method }: { enabled: boolean; method?: 'totp' | 'email' }) {
        if (state.consumer) {
            state.consumer.twoFactor = enabled
            if (method) {
                state.consumer.twoFactorMethod = method
            }
        }
    }
}
